import { useMutation } from '@tanstack/react-query';

import {
  downloadBillPatientListPdf,
  type BillPatientListPdfPayload,
} from '@/services/main/rezept';
import { useClinicContext } from './useClinicContext';

/**
 * 請求患者一覧 PDF (button on /rezepts/init).
 *
 * CP1: returns Blob | null. Caller opens via `window.open(URL.createObjectURL(blob))`.
 * null means BE returned 204 (no matching rezepts) → caller shows the no-data
 * popup. Server-supplied filename is lost in the blob URL — acceptable for CP1.
 */
export const useBillPatientListPdf = () => {
  const { tenant, clinicNumber } = useClinicContext();

  return useMutation({
    mutationFn: (payload: BillPatientListPdfPayload) =>
      downloadBillPatientListPdf(tenant ?? '', clinicNumber ?? '', payload),
  });
};

export default useBillPatientListPdf;
